<template>
    <Paper class='calculateRouter'>
        <m-panel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            searchId="calculateRouterManager_query"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            >
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-tooltip class="item" effect="dark" content="新增" placement="bottom" v-has="'08010001'">
                        <el-button class="bigData-btn-add" type='primary' size="mini" icon='el-icon-plus' @click="addData"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
                        <el-button class="bigData-btn-refresh" icon='el-icon-refresh' size="mini" @click="loadData" :loading="loading"></el-button>
                    </el-tooltip>
                </div>
            </div>
            <div slot="page-module-btn">
                <el-col>
                    <span v-has="'08010002'">
                        <el-button class="bigData-btn-save" type="primary" @click="saveData" :loading="loading">保存</el-button>
                    </span>
                    <span v-has="'08010003'" style="margin-left: 10px;">
                        <el-button class="bigData-btn-delete" type="primary" @click="delData" :loading="loading">删除</el-button>
                    </span>
                </el-col>
            </div>
        </m-panel>
    </Paper>
</template>
<script>
import mPanel from '@/components/otpPanel';
import Paper from '@/components/core/paper/Paper';
import config from './config.json';
import _ from '@/components/lots/utils';
import { getSession } from '@/utils/storage';
import calculateRouterAPI from '../../../../api/contract/payfileConfiguration';
export default {
    name: 'payfileConfiguration',
    data() {
        return {
            config: config,
            columns: config.table.columns,
            totalData: [],
            pageTotal: 100,
            editState: false,
            selectedRows: [],
            loading: false,
            checkedData: [],
            pageNo: 1,
            pageSize: 10,
            pageID: 'lsrm_payfile_configuration',
            searchTerm: {}
        };
    },
    methods: {
        addData() {
            // 表格新增方法
            const row = this.columns.reduce((result, col) => {
                result[col.prop] = col.defaultValue || '';
                return result;
            }, {});
            row.edit = 2;
            this.validatePropsIsDisabled(row);
            this.totalData.unshift(row);
            this.$refs.tablePage.$refs.table.$refs.mNewTable.$refs.moduleTable.toggleRowSelection(row, true);
        },
        // 校验属性禁用规则
        validatePropsIsDisabled(row) {
            row.disableProps = ['isLogisticsContract'];
        },
        selectChange(data) {
            // 表格内选择变化
            data.map(item => {
                this.validatePropsIsDisabled(item);
            });
            if (data.length > 0) {
                this.checkedData = data;
            } else {
                this.checkedData = [];
            }
        },
        searchChange(data) {
            this.pageNo = 1;
            this.searchTerm = data;
            this.loadData();
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        saveData() {
            const bidPaymentTerms = getSession('BID_PAYMENT_TERMS') || {};
            const that = this;
            const rows = _.clone(this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData());
            const rowsorigin = this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData();
            rowsorigin.map(item => {
                item.edit = 2;
            });
            let rule = true;
            if (!rows) {
                return;
            }
            if (Array.isArray(rows)) {
                rows.forEach(item => {
                    if (!(item.suppliersType && item.serviceType && item.property && item.isGroupCustomer && item.paymentTerms)) {
                        rule = false;
                    }
                    item.isGroupCustomer = Number(item.isGroupCustomer);
                    for (const key in bidPaymentTerms) {
                        if (bidPaymentTerms.hasOwnProperty(key) && key === String(item.paymentTerms)) {
                            item.substring1 = bidPaymentTerms[key];
                        }
                    }
                });
            }
            if (!rule) {
                this.$message.warning('配置内容未填完整');
                return;
            }
            if (rows.length !== 0) {
                calculateRouterAPI.save(rows).then(res => {
                    if (res) {
                        this.$message.success('保存成功！');
                        that.loadData();
                    }
                });
            }
        },
        delData() {
            const that = this;
            const routes = this.checkedData;
            if (routes.length === 0) {
                this.$message.warning('请勾选需要删除的数据');
            } else {
                const ids = [];
                routes.map(item => {
                    if (item.id) {
                        ids.push(item.id);
                    }
                });
                if (!ids.length) {
                    this.loadData();
                    return;
                }
                calculateRouterAPI.del(ids).then(res => {
                    if (res.code === '0') {
                        this.$message.success('删除成功！');
                        that.loadData();
                    } else {
                        this.$message.error(res.$message);
                    }
                });
            }
        },
        loadData() {
            this.loading = true;
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchTerm
            };
            calculateRouterAPI.search(params).then(res => {
                this.pageTotal = res.data.totalCount;
                this.totalData = res.data.list;
                this.totalData.map(item => {
                    item.isLogisticsContract = String(item.isLogisticsContract);
                    item.isGroupCustomer = String(item.isGroupCustomer);
                    item.paymentTerms = String(item.paymentTerms);
                    item.serviceType = String(item.serviceType);
                    item.property = String(item.property);
                    item.suppliersType = String(item.suppliersType);
                });
                this.editState = false;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.loadData();
    },
    components: { Paper, mPanel }
};
</script>
<style lang='less'>
   .calculateRouter{
        padding: 9px 16px 10px 16px !important;
   }
</style>
